export default __webpack_public_path__ + "static/media/planticon_3.e2d9aa63.png";